import { Input, InputNumber } from "antd";
import { ModalProps } from "antd/es/modal";
import React, { useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { ConfirmationModal } from "../../../../../../modals/confirmationmodal/ConfirmationModal";
import { InfoLabel } from "../../../../../../modals/customerservicemodal/panes/detailinfopane/sections/infofields/InfoLabel";
import { Message } from "../../../../../../modals/customerservicemodal/panes/messagesPane/message/Message";

interface IProps extends ModalProps {
    closeModal: () => void;
    onConfirm: (submittedBy: string, restAmount: number, msg?: string) => void;
}

const MESSAGES = defineMessages({
    optionalMessage: {
        id: "placement_form_modal.optional_message",
        defaultMessage: "Optioneel bericht voor Customer Service:"
    },
    estimate: {
        id: "pre_modal.estimate",
        defaultMessage: "Geschatte hoeveelheid (kg)"
    },
    submittedBy: {
        id: "rest_found_modal.submittedBy",
        defaultMessage: "Ingediend door"
    }
});

export const RestFoundModal = (props: IProps) => {
    const [msg, setMsg] = useState<string | undefined>();
    const [submittedBy, setSubmittedBy] = useState<string | undefined>();
    const [restInput, setRestInput] = useState<number | undefined>();
    const intl = useIntl();

    const onConfirm = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        props.onConfirm(submittedBy, restInput, msg);
    };

    return (
        <ConfirmationModal
            {...props}
            title={null}
            onConfirm={onConfirm}
            disabled={!restInput || !submittedBy}
        >
            <h2>{props.title}</h2>
            <InfoLabel text={intl.formatMessage(MESSAGES.estimate)}/>
            <InputNumber
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                onChange={setRestInput}
                className="margin-half-left"
            />
            <Message title={intl.formatMessage(MESSAGES.optionalMessage)} editable onChange={setMsg} className="margin-top"/>
            <InfoLabel text={intl.formatMessage(MESSAGES.submittedBy)} className="margin-top inline-block"/>
            <Input value={submittedBy} onChange={(e) => setSubmittedBy(e.target.value)} className="margin-half-top"/>
        </ConfirmationModal>
    );
};
